import React from 'react';
import { Nav, NavItem, Collapse, UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom';
import styles from './Header.module.scss';

function Menu({ isOpen }) {
  return (
    <Collapse isOpen={!!isOpen} navbar className={styles['navbar-collapse']}>
      <Nav className={`${styles['navbar-nav']}`} navbar>
        <NavItem className={`${styles['nav-item']} ${styles['nav-header']} d-md-none`}>
          Products <i className="fas fa-angle-down"></i>
        </NavItem>

        <NavItem className={styles['nav-item']}>
          <Link className={styles['nav-link']} to="/motor-insurance/">Car <span className="d-md-none">Insurance</span></Link>
        </NavItem>

        <NavItem className={styles['nav-item']}>
          <Link className={styles['nav-link']} to="/home-insurance/">Home <span className="d-md-none">Insurance</span></Link>
        </NavItem>

        <UncontrolledDropdown nav className={styles['nav-item']}>
          <DropdownToggle nav caret className={`${styles['nav-link']}`}>
            Business <span className="d-inline d-md-none">Insurance</span>
          </DropdownToggle>

          <DropdownMenu className={styles['dropdown-menu']}>
            <NavItem className={`${styles['dropdown-item']} dropdown-item`}>
              <Link className={styles['nav-link']} to="/business-insurance/small-business">
                Small Business <span className="d-none d-md-inline">Insurance</span>
              </Link>
            </NavItem>

            <NavItem className={`${styles['dropdown-item']} dropdown-item`}>
              <Link className={styles['nav-link']} to="/business-insurance/event-liability">
                Event Liability
              </Link>
            </NavItem>
          </DropdownMenu>
        </UncontrolledDropdown>

        <UncontrolledDropdown nav className={`${styles['nav-item']} d-none d-md-inline`}>
          <DropdownToggle nav caret className={`${styles['nav-link']}`}>
            Customer Care
          </DropdownToggle>
          <DropdownMenu className={styles['dropdown-menu']}>
            <NavItem className={`${styles['dropdown-item']} dropdown-item`}>
              <Link className={styles['nav-link']} to="/customer-care/claims-support">
                Claims Support
              </Link>
            </NavItem>

            <NavItem className={`${styles['dropdown-item']} dropdown-item`}>
              <Link className={styles['nav-link']} to="/customer-care/faq">
                FAQ
              </Link>
            </NavItem>

            <NavItem className={`${styles['dropdown-item']} dropdown-item`}>
              <Link className={styles['nav-link']} to="/customer-care/contact-us">
                Contact Us
              </Link>
            </NavItem>

            <NavItem className={`${styles['dropdown-item']} dropdown-item`}>
              <Link className={styles['nav-link']} to="/payments">
                Payments
              </Link>
            </NavItem>
          </DropdownMenu>
        </UncontrolledDropdown>

        <NavItem className={`${styles['nav-item']} ${styles['nav-header']}`}>
          <Link className={styles['nav-link']} to="/about-us/">About Us</Link>
        </NavItem>
      </Nav>
    </Collapse>
  )
}

export default Menu;
